var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, property } from "lit-element";
export class FetchElement extends LitElement {
    constructor() {
        super(...arguments);
        this.fetchUrl = "";
        this.updateIntervalSeconds = 10;
    }
    getData() {
        fetch(this.fetchUrl, { credentials: 'include' })
            .then(response => response.json())
            .then(json => this._fetchData = { fetchSuccessful: true, json: json })
            .catch(error => this._fetchData = { fetchSuccessful: false, json: error })
            .then(() => this.scheduleNextFetch());
    }
    scheduleNextFetch() {
        this._updateTimer = setTimeout(this.getData.bind(this), this.updateIntervalSeconds * 1000);
    }
    updated(changedProperties) {
        if (changedProperties.has('updateIntervalSeconds')) {
            clearTimeout(this._updateTimer);
            this.getData();
        }
    }
    renderBeforeFetch() {
        return html `Loading <a href="${this.fetchUrl}">data</a>...`;
    }
    renderAfterFetch() {
        return this._fetchData.fetchSuccessful ? this.renderOnFetchSuccessful() : this.renderOnFetchError();
    }
    renderOnFetchSuccessful() {
        return html `Method renderOnFetchSuccessful() not implemented in component!`;
    }
    renderOnFetchError() {
        return html `
      <p>Error while fetching data from <a href="${this.fetchUrl}">${this.fetchUrl}</a>. Check fetch URL.</p>
      <p>${this._fetchData.json}</p>
    `;
    }
    render() {
        return this._fetchData ? this.renderAfterFetch() : this.renderBeforeFetch();
    }
}
__decorate([
    property({ type: String })
], FetchElement.prototype, "fetchUrl", void 0);
__decorate([
    property({ type: Number })
], FetchElement.prototype, "updateIntervalSeconds", void 0);
__decorate([
    property({ type: Object })
], FetchElement.prototype, "_fetchData", void 0);
__decorate([
    property({ type: Number })
], FetchElement.prototype, "_updateTimer", void 0);
